import Vue from 'vue';

Vue.component('app', require('../App.vue').default);

Vue.filter('dateFormat', function (value) {
    if (value) {
        return dateTimeFormat.format(new Date(value));
    }
    return null;
});

Vue.filter('dateConvenientFormat', function (value) {
    if (value) {
        let today = new Date();
        let date = new Date(value);

        let isToday = today.toDateString() === date.toDateString();
        let isCurrentYear = today.getFullYear() === date.getFullYear();

        return isToday
            ? dateTimeFormatHourMinute.format(date)
            : isCurrentYear
                ? dateTimeFormatDayMonth.format(date)
                : dateTimeFormat.format(date);
    }
});

Vue.filter('timeFormat', function (value) {
    if (value) {
        return dateTimeFormatHourMinute.format(new Date(value));
    }
});

Vue.filter('currencyFormat', function (value) {
    return currencyNumberFormat.format(value);
});

export default Vue;
